import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { LocationActions } from '../../actions';
import Loader from '../../components/Loader';
import SubnavBar from '../../components/SubnavBar';
import TitleBar from '../../components/TitleBar';
import List from '../../components/Locations/List';
import DeleteLocationConfirm from '../Modals/DeleteLocationConfirmation';

class Locations extends Component {
  constructor(props) {
    super(props);

    this.selectLocation = this.selectLocation.bind(this);
    this.deleteLocation = this.deleteLocation.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);

    this.state = {
      open: false,
      editable: false,
      loctionId: null,
    };
  }
  componentWillMount() {
    const { locations } = this.props;
    if (!locations) {
      this.props.dispatch(LocationActions.getLocations());
    }
  }
  newLocation = () => {
    browserHistory.push('/location');
  }
  deleteLocation() {
    this.setState({
      open: true
    });
  }
  confirmDelete() {
    this.props.dispatch(LocationActions.deleteLocation(this.state.locationId)).then(() => {
      this.setState({
        open: false,
      });
      this.props.dispatch(LocationActions.getLocations());
    });
  }

  handleClose() {
    this.setState({
      open: false,
    });
  }
  
  selectLocation(d) {
    const editable = (d.length > 0);
    const locationId = (editable) ? this.props.locations.list[d[0]].id : null;
    this.setState({
      editable,
      locationId
    });
  }

  render() {
    const { user, locations } = this.props;
    const role = _.get(user, 'profile.roles');
    const isAdmin = _.includes(['super-admin', 'carrier-admin'], role);
    const isDispatch = _.includes(['super-admin', 'carrier-admin', 'carrier-dispatch'], role);
    let content;
  
    if (!locations || locations.fetching || !locations.list) {
      content = <Loader />;
    } else {
      content = <List isAdmin={isAdmin || isDispatch} onSelect={this.selectLocation} />;
    }

    const subnavItems = [{ key: 1, label: 'New', onClick: this.newLocation }, { key: 2, label: 'Delete', onClick: this.deleteLocation, disabled:!this.state.editable }]
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Locations" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
        <DeleteLocationConfirm onClose={this.handleClose} onConfirm={this.confirmDelete} open={this.state.open} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { locations, user } = state;
  return {
    user,
    locations
  }
}

export default connect(mapStateToProps)(Locations);



// WEBPACK FOOTER //
// ./src/containers/Locations/index.js